import { EnterpriseContactSalesPageTemplate } from "@/templates/enterprise-contact-sales-page";

export const EnterpriseContactSalesPage = () => (
    <EnterpriseContactSalesPageTemplate />
);
